import { ActionTypeList } from '../../constants/index'

const initialState = {
    loading: false,
    data: null,
    error: "",
};

const feedbackUpdateStatusPayload = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypeList.FEEDBACK_UPDATED:
            return {
                loading: false,
                data: action.payload,
                error: ""
            };
        case ActionTypeList.FEEDBACK_UPDATE:
            return {
                loading: true,
                data: action.payload,
                error: action.payload
            };
        case ActionTypeList.FEEDBACK_UPDATE_STATUS_RESET:
            return {
                ...state,
                ...initialState
            };
        default:
            return state;
    }
}

export default feedbackUpdateStatusPayload;